import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import axios from 'axios';

//React export function used to display the shipper address block
export default function ShipperAddress() {

    //Setting the states
    const [values, setValues] = useState([]);


    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/Get`)
            .then((res) => {
                    setValues(res.data);
                    setSessionVariable(res.data[0].id);
            })
            .catch((e) => {
                console.log('AccountOrganisation error occurred with the API process');
            });
    }, []);

    function setSessionVariable(id) {
        sessionStorage.removeItem('COAccountID');
        sessionStorage.setItem('COAccountID', id);
    }

    //Render the dropdowns onto the screen
    return (
        <React.Fragment>
            <GridContainer>
                <GridItem xs={12}>
                    {values.map(value =>
                        <GridContainer>
                            <GridItem xs={12}>
                                <TextField
                                    name="accountID"
                                    id="accountID"
                                    label="Account Holder"
                                    InputLabelProps={{ shrink: true, required: true }}                    
                                    value={value.label}
                                    type="text"
                                    style={{ marginTop: '20px', width: '100%' }}
                                    size="small"
                                />
                            </GridItem>
                        </GridContainer>
                    )}
            </GridItem>
            </GridContainer>
        </React.Fragment>
    );
}

